export default {
  ru: {
    commons: {
      bar_hint: 'Продукцию можно получить в любое время в кассе бара по номеру заказа или qr коду',
      title: 'MULTIPLEX - личный кабинет'
    },
    header: {
      heading: 'Личный кабинет'
    },
    notify: {
      success: 'Данные изменены!',
      error: 'Не удалось сохранить данные, попробуйте еще раз'
    },
    top_section: {
      set_name: 'Укажите свое имя',
      points_to_new_lvl: 'Баллов до нового уровня',
      need_card: 'Необходимо приобрести карту',
      level: 'Уровень',
      points: 'Баллы',
      subscription: 'Подписка',
      buy_card: 'Приобрести карту',
      points_hint: 'Покупай билеты, открывай бейджи и зарабатывай баллы.',
      lev: 'ур.',
      copy: 'Копировать',
      copied: 'Скопировано',
      navigation: {
        main: 'Главная',
        tickets_and_bar: 'Билеты и бар',
        support: 'Поддержка',
        profile: 'Профиль'
      }
    },
    pop_ups: {
      left_menu: {
        now_in_cinema: 'Сейчас в кино',
        soon: 'Скоро в прокате',
        promos: 'Акции и скидки',
        cinemas: 'Кинотеатры',
        faq: 'Помощь',
        about: 'О компании',
        personal: 'Личный кабинет',
        logout: 'Выйти'
      },
      change_name: {
        heading: 'Введите Ваше имя',
        name: 'Имя',
        surname: 'Фамилия',
        save: 'Сохранить',
        err_name_required: 'Необходимо ввести имя',
        err_surname_required: 'Необходимо ввести фамилию'
      },
      qr_code: {
        ticket: 'Билет',
        row: 'Ряд',
        place: 'Место'
      },
      next_lvl_requirements: {
        achieve_start: 'Для достижения ',
        achieve_end: '-го уровня необходимо:',
        points: 'баллов',
        program_dets: 'Подробнее о программе лояльности',
        close: 'Закрыть'
      },
      family_unit: {
        family_member: 'Член семьи'
      }
    },
    main_page: {
      tickets: {
        heading: 'Ваши билеты',
        num_tickets: 'Билетов',
        date_start: 'Дата и начало',
        cinema: 'Кинотеатр',
        address: 'Адрес',
        print: 'Скачать билеты',
        qr: 'Qr код',
        share: 'Поделиться',
        no_tickets: 'У Вас нет активных билетов',
        time_to_buy: 'Самое время приобрести их:)',
        order_num: '№ заказа',
        bar_goods: 'Товары бара',
        show: 'Посмотреть',
        hide: 'Скрыть',
        return: 'Вернуть',
        just_show: 'Просто открой эту страницу с телефона и покажи QR на входе в зал'
      },
      featured_movies: {
        heading: 'Интересные фильмы'
      },
      bar_goods: {
        heading: 'Еда и напитки'
      },
      special_offers: {
        heading: 'Специальные предложения'
      },
      badges: {
        heading: 'Бейджи',
        open: 'Открытые',
        closed: 'Закрытые'
      }
    },
    tickets_and_bar: {
      tickets: {
        heading: 'Ваши билеты',
        duration: 'Длительность',
        quantity: 'Количество',
        city_cinema: 'Город/Кинотеатр',
        date: 'Дата',
        time: 'Время',
        print: 'Скачать билеты',
        date_and_start: 'Дата и начало',
        num_tickets: 'Количество билетов',
        cinema: 'Кинотеатр',
        address: 'Адрес',
        qr_code: 'QR код',
        no_tickets: 'У Вас нет активных билетов',
        time_to_buy: 'Самое время приобрести их:)',
        order_num: '№ заказа'
      },
      bar: {
        heading: 'Еда и напитки'
      },
      operations: {
        heading: 'Недавние операции',
        oper_dt: 'Дата операции',
        ta_num: '№ заказа',
        sess_dt: 'Дата сеанса',
        mvi: 'Фильм',
        num_tickets: 'Количество',
        cost_uah: 'Стоимость, грн',
        more: 'Показать еще',
        no_more: 'Больше операций нет',
        oper_expl: 'Это история всех покупок с Вашим номером телефона',
        det_open: 'Подробнее',
        det_close: 'Свернуть',
        tickets_refunded: 'Билеты возвращены',
        tickets: 'Билеты',
        cost: 'Стоимость',
        dets: 'Детали',
        num_order: '№ заказа',
        bar_goods: 'Товары бара',
        row: 'Ряд',
        seat: 'место'
      }
    },
    m_friends: {
      about_program_short: 'О программе',
      about_program_long: 'О программе лояльности',
      about_levels: 'Об уровнях и подписке',
      badges: 'Бейджи',
      rules: 'Правила программы',
      rules_short: 'Правила',
      lvl_requirements: 'Требования',
      lvl_reward: 'Награда',
      subscriptions: 'Подписки'
    },
    support: {},
    profile: {
      heading: 'Ваш профиль',
      save: 'Сохранить',
      cancel: 'Отменить',
      delete: 'Удалить',
      why_this_data: 'Для чего нам эти данные?',
      incorrect_date: 'Некорректная дата рождения',
      try_again: 'Попробуйте еще раз',
      your_cards: 'Ваши карты',
      show_cards: 'Показать',
      not_seted: 'не указано',
      contact_info: {
        heading: 'Контактная информация',
        your_city: 'Ваш город',
        cell_phone: 'Мобильный телефон',
        soc_networks: 'Соц. сети',
        why_explain: 'С номером телефона вы сможете увидеть все свои заказы. Почта нужна для резервного доступа в кабинет',
        cell_phone_replacement: {
          heading: 'Замена мобильного телефона',
          new_phone_number: 'Новый номер телефона',
          next: 'Далее',
          cancel: 'Отменить',
          confirmation_expl: 'На указанный Вами номер телефона был отправлен код. Пожалуйста, введите его в поле ниже. После успешного подтверждения Вы сможете войти с в личный кабинет с новым номером телефона',
          code: 'Код',
          save: 'Сохранить',
          wrong_code: 'Код введен неверно',
          cp_explain: 'На новый и старый номера телефонов будут отправлены смс-сообщения'
        },
        email_replacement: {
          heading: 'Замена электронного адреса',
          new_email: 'Новый E-mail',
          next: 'Далее',
          cancel: 'Отменить',
          confirmation_expl_1: 'На E-mail',
          confirmation_expl_2: 'было отправлено письмо. Пожалуйста, перейдите по ссылке в письме для подтверждения операции',
          save: 'Сохранить',
          invalid_email: 'Введите корректный E-mail',
          back: 'Назад',
          enter_other: 'Ввести другой адрес',
          not_received: 'Не получили письмо?'
        }
      },
      personal_info: {
        heading: 'Персональная информация',
        why_explain: 'Расскажи о себе! Мы уже планируем подарки для тебя и твоих родных',
        name: 'Имя',
        surname: 'Фамилия',
        marital_status: 'Семейное положение',
        birthday: 'Дата рождения',
        family: 'Семья',
        gender: 'Пол',
        male: 'Мужской',
        female: 'Женский',
        add: 'Добавить',
        birthday_hint: 'Чтобы изменить дату рождения, Вам нужно выслать фото паспорта через',
        birthday_hint_link: 'форму обратной связи'
      },
      other_info: {
        heading: 'Другая информация',
        why_explain: 'Раздел для будущих персональных предложений',
        social_status: 'Вид занятости',
        favorite_cinema: 'Любимый кинотеатр',
        car: 'Автомобиль'
      }
    },
    login: {
      heading: 'Вход в личный кабинет',
      provide_phone: 'Введите номер телефона',
      here_all: 'Здесь все ваши заказы, платежные карты и личная информация.',
      send_code: 'Отправить код',
      phone: 'Номер мобильного',
      too_many_requests: 'Слишком много запросов SMS с Вашего IP-адреса',
      next: 'Далее',
      back: 'Назад',
      to_phone: 'На телефон',
      sent_sms: 'отправлен SMS с кодом подтверждения',
      confirm_phone: 'Подтвердите номер телефона',
      change_phone: 'Поменять номер',
      enter_code: 'Введіть код, відправлений на номер:',
      code_from_sms: 'Код подтверждения',
      resend: 'Отправить код повторно',
      after: 'через',
      wrong_code: 'Код подтверждения неверный',
      enter: 'Войти',
      sms_sent_waiting: 'СМС отправлено, ожидаем доставки...',
      code_delivered: 'Проверочный код успешно доставлен',
      in_push: 'в PUSH-уведомлении',
      in_sms: 'в SMS',
      in_viber: 'в Viber',
      delivery_service_down: 'Сервис доставки сообщений не отвечает',
      mes_expired: 'К сожалению, Ваше сообщение не было доставлено в необходимый срок.',
      cell_problems: 'К сожалению, Ваше сообщение не было доставлено из-за проблем сотовой сети',
      resend_sms: 'Отправить СМС еще раз',
      no_download_print: 'Не нужно качать или печатать!',
      all_in_cabinet: 'Билеты уже в Вашем кабинете - просто авторизуйтесь сейчас и предъявите QR-код при входе в кинозал.',
      service_unavailable: 'Сервис временно недоступен. Попробуйте позже'
    }
  },
  ua: {
    commons: {
      bar_hint: 'Продукцію можна отримати в будь-який час в касі бару за номером замовлення або qr кодом',
      title: 'MULTIPLEX - особистий кабінет'
    },
    header: {
      heading: 'Особистий кабінет'
    },
    notify: {
      success: 'Дані змінено!',
      error: 'Не вдалось зберегти дані, спробуйте ще раз'
    },
    top_section: {
      set_name: 'Вкажіть своє ім’я',
      points_to_new_lvl: 'Балів до нового рівня',
      need_card: 'Необхідно придбати карту',
      level: 'Рівень',
      points: 'Бали',
      subscription: 'Підписка',
      buy_card: 'Придбати карту',
      points_hint: 'Купуй квитки, відкривай бейджі та заробляй бали.',
      lev: 'рів.',
      copy: 'Копіювати',
      copied: 'Скопійовано',
      navigation: {
        main: 'Головна',
        tickets_and_bar: 'Квитки і бар',
        support: 'Підтримка',
        profile: 'Профіль'
      }
    },
    pop_ups: {
      left_menu: {
        now_in_cinema: 'Зараз у кіно',
        soon: 'Скоро у прокаті',
        promos: 'Акції та знижки',
        cinemas: 'Кінотеатри',
        faq: 'Допомога',
        about: 'Про компанію',
        personal: 'Особистий кабінет',
        logout: 'Вийти'
      },
      change_name: {
        heading: 'Введіть Ваше ім’я',
        name: 'Ім’я',
        surname: 'Прізвище',
        save: 'Зберегти',
        err_name_required: 'Необхідно ввести ім’я',
        err_surname_required: 'Необхідно ввести прізвище'
      },
      qr_code: {
        ticket: 'Квиток',
        row: 'Ряд',
        place: 'Місце'
      },
      next_lvl_requirements: {
        achieve_start: 'Для досягнення ',
        achieve_end: '-го рівня необхідно:',
        points: 'балів',
        program_dets: 'Детальніше про програму лояльності',
        close: 'Закрити'
      },
      family_unit: {
        family_member: 'Член сім’ї'
      }
    },
    main_page: {
      tickets: {
        heading: 'Ваші квитки',
        num_tickets: 'Квитків',
        date_start: 'Дата і початок',
        cinema: 'Кінотеатр',
        address: 'Адреса',
        print: 'Зберегти',
        qr: 'Qr код',
        share: 'Поділитися',
        no_tickets: 'У Вас немає активних квитків',
        time_to_buy: 'Саме час придбати їх:)',
        order_num: '№ замовлення',
        bar_goods: 'Товари бару',
        show: 'Дивитись',
        hide: 'Сховати',
        return: 'Повернути',
        just_show: 'Просто відкрий цю сторінку з телефону та покажи QR на вході до залу'
      },
      featured_movies: {
        heading: 'Цікаві фільми'
      },
      bar_goods: {
        heading: 'Їжа та напої'
      },
      special_offers: {
        heading: 'Спеціальні пропозиції'
      },
      badges: {
        heading: 'Бейджі',
        open: 'Відкриті',
        closed: 'Закриті'
      }
    },
    tickets_and_bar: {
      tickets: {
        heading: 'Ваші квитки',
        duration: 'Тривалість',
        quantity: 'Кількість',
        city_cinema: 'Місто/Кінотеатр',
        date: 'Дата',
        time: 'Час',
        print: 'Зберегти квитки',
        date_and_start: 'Дата і початок',
        num_tickets: 'Кількість квитків',
        cinema: 'Кінотеатр',
        address: 'Адреса',
        qr_code: 'QR код',
        no_tickets: 'У Вас немає активних квитків',
        time_to_buy: 'Саме час придбати їх:)',
        order_num: '№ замовлення'
      },
      bar: {
        heading: 'Їжа та напої'
      },
      operations: {
        heading: 'Нещодавні операції',
        oper_dt: 'Дата операції',
        ta_num: '№ замовлення',
        sess_dt: 'Дата сеансу',
        mvi: 'Фільм',
        num_tickets: 'Кількість',
        cost_uah: 'Вартість, грн',
        more: 'Показати ще',
        no_more: 'Більше операцій немає',
        oper_expl: 'Це історія всіх покупок з Вашим номером телефону',
        det_open: 'Детальніше',
        det_close: 'Згорнути',
        tickets_refunded: 'Квитки повернуто',
        tickets: 'Квитки',
        cost: 'Вартість',
        dets: 'Деталі',
        num_order: '№ замовлення',
        bar_goods: 'Товари бару',
        row: 'Ряд',
        seat: 'місце'
      }
    },
    m_friends: {
      about_program_short: 'Про програму',
      about_program_long: 'Про програму лояльності',
      about_levels: 'Про рівні та підписку',
      badges: 'Бейджі',
      rules: 'Правила програми',
      rules_short: 'Правила',
      lvl_requirements: 'Вимоги',
      lvl_reward: 'Винагорода',
      subscriptions: 'Підписки'
    },
    support: {},
    profile: {
      heading: 'Ваш профіль',
      save: 'Зберегти',
      cancel: 'Скасувати',
      delete: 'Видалити',
      why_this_data: 'Для чого нам ці дані?',
      incorrect_date: 'Некоректна дата народження',
      try_again: 'Cпробуйте ще раз',
      your_cards: 'Ваші картки',
      show_cards: 'Показати',
      not_seted: 'не вказано',
      contact_info: {
        heading: 'Контактна інформація',
        your_city: 'Ваше місто',
        cell_phone: 'Мобільный телефон',
        soc_networks: 'Соц. мережі',
        why_explain: 'З номером телефону ви зможете побачити всі свої замовлення. Пошта потрібна для резервного доступу в кабінет',
        cell_phone_replacement: {
          heading: 'Зміна мобільного телефону',
          new_phone_number: 'Новий номер телефону',
          next: 'Далі',
          cancel: 'Скасувати',
          confirmation_expl: 'На вказаний Вами номер телефону було відправлено код. Будь ласка, введіть його в поле нижче. Після успішного підтвердження Ви зможете увійти в особистий кабінет з новим номером телефону',
          code: 'Код',
          save: 'Зберегти',
          wrong_code: 'Код введено невірно',
          cp_explain: 'На новий та старий номери телефонів будуть відправлені смс-повідомлення'
        },
        email_replacement: {
          heading: 'Зміна електронної адреси',
          new_email: 'Новий E-mail',
          next: 'Далі',
          cancel: 'Скасувати',
          confirmation_expl_1: 'На E-mail',
          confirmation_expl_2: 'було відправлено листа. Будь ласка, перейдіть за посиланням в листі для підтвердження операції',
          save: 'Зберегти',
          invalid_email: 'Введіть коректний E-mail',
          back: 'Назад',
          enter_other: 'Ввести іншу адресу',
          not_received: 'Не отримали листа?'
        }
      },
      personal_info: {
        heading: 'Персональна інформація',
        name: 'Ім’я',
        why_explain: 'Розкажи про себе! Ми вже плануємо подарунки для тебе та твоїх рідних',
        surname: 'Прізвище',
        marital_status: 'Сімейний стан',
        birthday: 'Дата народження',
        family: 'Сім’я',
        gender: 'Стать',
        male: 'Чоловіча',
        female: 'Жіноча',
        add: 'Додати',
        birthday_hint: 'Щоб змінити дату народження, Вам необхідно надіслати фото паспорта через',
        birthday_hint_link: 'форму зворотнього зв’язку'
      },
      other_info: {
        heading: 'Інша інформація',
        why_explain: 'Розділ для майбутніх персональних пропозицій',
        social_status: 'Вид зайнятості',
        favorite_cinema: 'Улюблений кінотеатр',
        car: 'Автомобіль'
      }
    },
    login: {
      heading: 'Вхід до особистого кабінету',
      provide_phone: 'Введіть номер телефону',
      here_all: 'Тут всі ваші замовлення, платіжні картки та особиста інформація',
      send_code: 'Відправити код',
      phone: 'Номер мобільного',
      too_many_requests: 'Занадто багато запитів SMS з Вашої IP-адреси',
      next: 'Далі',
      back: 'Назад',
      to_phone: 'На телефон',
      sent_sms: 'відправлено SMS із кодом підтвердження',
      confirm_phone: 'Підтвердіть номер телефону',
      change_phone: 'Змінити номер',
      enter_code: 'Введіть код, відправлений на номер:',
      code_from_sms: 'Код підтвердження',
      resend: 'Відправити код повторно',
      after: 'через',
      wrong_code: 'Код підтвердження невірний',
      enter: 'Увійти',
      sms_sent_waiting: 'СМС відправлено, очікуємо доставки...',
      code_delivered: 'Код перевірки успішно доставлено',
      in_push: 'в PUSH-повідомленні',
      in_sms: 'в SMS',
      in_viber: 'в Viber',
      delivery_service_down: 'Сервіс доставки повідомлень не відповідає',
      mes_expired: 'На жаль, Ваше повідомлення не було доставлено в необхідний термін.',
      cell_problems: 'На жаль, Ваше повідомлення не було доставлено через проблеми сотової мережі',
      resend_sms: 'Відправити СМС еще раз',
      no_download_print: 'Не потрібно завантажувати або друкувати!',
      all_in_cabinet: 'Квитки вже у Вашому кабінеті - просто авторизуйтесь зараз і покажіть QR-код при вході в кінозал.',
      service_unavailable: 'Сервіс тимчасово недоступний. Спробуйте пізніше'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang.js